// Whether the server's event stream is connected. While it is, data on screen
// is pushed or invalidated by events, and polling only backs it up.

let live = false;

export function isStreamLive(): boolean {
  return live;
}

/** Record the stream's state; true when it changed. */
export function setStreamLive(value: boolean): boolean {
  const changed = value !== live;
  live = value;
  return changed;
}
